import { create } from "zustand";

/**
 * The connecting splash (ServerConnectGate) is on screen. The game mounts under
 * it as soon as the player's data is in, so the map is built while the splash
 * still shows; popups wait until it is gone (MapModals → popup director).
 */
const useSplashStore = create<{ visible: boolean }>(() => ({ visible: true }));

export default useSplashStore;
